export enum ApiMessage {
    SENT_FOR_APPROVAL = 'Product has been sent for approval',
}
